
      export default {
        // The widget renders as the page mounts, so its check runs while the
        // person types. It stays in Cloudflare's default render mode with
        // automatic refresh. Each callback reports to the server, which holds
        // the token in the hidden field and enables "Send magic link" only
        // while it holds one.
        mounted() {
          this.renderWidget();
          // A refused request has spent the token, so the server asks for a
          // fresh one.
          this.handleEvent("reset_turnstile", () => {
            if (window.turnstile && this.widgetId !== undefined) {
              window.turnstile.reset(this.widgetId);
            }
          });
        },
        renderWidget() {
          if (this._destroyed) return;
          if (!window.turnstile) {
            this.timer = setTimeout(() => this.renderWidget(), 50);
            return;
          }
          // "flexible" fills the form but is never narrower than 300px, so a
          // narrower form gets Cloudflare's 150px "compact" widget instead.
          this.widgetId = window.turnstile.render(this.el, {
            sitekey: this.el.dataset.sitekey,
            size: this.el.clientWidth >= 300 ? "flexible" : "compact",
            callback: (token) => this.pushEvent("turnstile_verified", { token: token }),
            "error-callback": () => this.pushEvent("turnstile_reset", {}),
            // A token expires a few minutes after the check passes. The widget
            // then fetches a new one by itself, so the button is off only until
            // the next callback turns it back on, and a slow typist still
            // submits a live token.
            "expired-callback": () => this.pushEvent("turnstile_reset", {})
          });
        },
        destroyed() {
          this._destroyed = true;
          if (this.timer) clearTimeout(this.timer);
          if (window.turnstile && this.widgetId !== undefined) {
            window.turnstile.remove(this.widgetId);
          }
        }
      }
    